import { createEmptyUser } from "../../features/user/types/user.functions";
import { toString } from "../../utils/type.utils";

import { TExecutionBriefResults } from "../reducers/executionBriefsReducer";

export function executionBriefNormaliseFormData(
  data: TExecutionBriefResults
): TExecutionBriefResults {
  return {
    ...data,

    areVendorAssetsProvided: data.areVendorAssetsProvided ?? false,
    audience: data.audience ?? "",
    background: data.background ?? "",
    briefOwner: data.briefOwner ?? createEmptyUser(),
    businessObjectives: data.businessObjectives ?? "",
    copyDirection: data.copyDirection ?? "",
    creativeDirection: data.creativeDirection ?? "",
    date: data.date ?? "",
    endAt: data.endAt ?? "",
    executionDetails: data.executionDetails ?? "",
    flyerPeriod: data.flyerPeriod ?? "",
    hasVendorCommitment: data.hasVendorCommitment ?? false,
    isInventoryAvailable: data.isInventoryAvailable ?? false,
    isRegional: data.isRegional ?? false,
    keyMessage: data.keyMessage ?? "",
    languages: data.languages ?? [],
    merchOwners: data.merchOwners ?? [],
    numberOfWorkOrdersRequested: toString(data.numberOfWorkOrdersRequested),
    programObjectives: data.programObjectives ?? "",
    projectOverview: data.projectOverview ?? "",
    regions: data.regions ?? [],
    reportingMasterCampaignName: data.reportingMasterCampaignName ?? "",
    startAt: data.startAt ?? "",
    storeNumber: data.storeNumber ?? "",
    storeType: toString(data.storeType),
    vendorAssetsLocation: data.vendorAssetsLocation ?? "",
  };
}
